
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, CheckCircle } from "lucide-react";

export function Newsletter() {
  const [email, setEmail] = useState("");
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      // Simular envio do email para contato@brendanutricionista.com.br
      console.log(`Enviando newsletter para: contato@brendanutricionista.com.br`);
      console.log(`Email inscrito: ${email}`);
      
      // Aqui você integraria com um serviço de email como Mailchimp, SendGrid, etc.
      // Para simular, vamos apenas mostrar uma mensagem de sucesso
      setIsSubscribed(true);
      setEmail("");
      
      // Reset após alguns segundos
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  return (
    <section className="py-12 sm:py-16 bg-green-600">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <Mail className="w-12 h-12 text-white mx-auto mb-6" />
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 font-primary">
            Receba Nossos Artigos
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-green-100 mb-8 font-secondary">
            Assine nossa newsletter e receba dicas exclusivas de nutrição diretamente em seu email
          </p>

          {isSubscribed ? (
            <div className="bg-white rounded-lg p-6 flex items-center justify-center gap-3">
              <CheckCircle className="w-6 h-6 text-green-600" />
              <span className="text-green-600 font-medium">
                Obrigada por se inscrever! Enviamos um email de confirmação.
              </span>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <Input
                type="email"
                placeholder="Seu melhor email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 bg-white border-white text-gray-800 placeholder-gray-500"
              />
              <Button 
                type="submit"
                className="bg-white text-green-600 hover:bg-gray-100 font-accent px-6 sm:px-8"
              >
                Assinar
              </Button>
            </form>
          )}

          <p className="text-green-100 text-sm mt-4">
            Prometemos não enviar spam. Você pode cancelar a qualquer momento.
          </p>
        </div>
      </div>
    </section>
  );
}
